const hostUrl = '/';
const createRecipePath = 'api/recipes/'

function createRecipe(formData) {
    return fetch(`${hostUrl}${createRecipePath}`, {
        method: 'POST',
        body: formData,
        headers: {
            authorization: `Bearer ${localStorage.getItem('session')}`,
        }
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Invalid response code');
        });
}

export { createRecipe };
